import type { Action } from 'redux';
import dash_api from '../../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { GetPinterestAuthenticationUrlPayload } from '../Pinterest.types';

const GetPinterestAuthenticationUrl = new ReduxAsyncAction<
  'GET_PINTEREST_AUTHENTICATION_URL',
  string,
  GetPinterestAuthenticationUrlPayload
>('GET_PINTEREST_AUTHENTICATION_URL');
GetPinterestAuthenticationUrl.registerRequest((authToken: string) => {
  return dash_api.get(`/v1/pinterest/get-auth-url?authToken=${authToken}`).then(({ data }) => {
    return data;
  });
});
export const GET_PINTEREST_AUTHENTICATION_URL = GetPinterestAuthenticationUrl.actionNamespaceConstants;
export const getPinterestAuthenticationUrl = GetPinterestAuthenticationUrl.request;

export type GetPinterestAuthenticationUrlAction = Action<typeof GET_PINTEREST_AUTHENTICATION_URL.response> & {
  data: GetPinterestAuthenticationUrlPayload;
};
